import { defineStore } from 'pinia';
import { computed } from 'vue';

const featureFlagsStore = defineStore('feature-flags', () => {
  const isTesting = computed(
    () => String(import.meta.env.VITE_FF_IS_TESTING).toLowerCase() === 'true'
  );

  return {
    // Computed
    isTesting,
  };
});

export default featureFlagsStore;
